import FormLabel from '@mui/material/FormLabel';
import InputAdornment from '@mui/material/InputAdornment';
import type { InputBaseProps } from '@mui/material/InputBase';
import TextField, { type TextFieldSlotsAndSlotProps } from '@mui/material/TextField';
import { FormFieldWithInfo } from '@openx/components-core/lib/FormFieldWithInfo/FormFieldWithInfo';
import { useId } from 'react';
import { useTranslation } from 'react-i18next';
import { netFeeTooltip } from '../../../../../components/CuratedDealFees/constants';
import { useIsCpmRevenue } from '../../hooks/useIsCpmRevenue';
import { useNetFeeCalculation } from '../../hooks/useNetFeeCalculation';

type NetFeeProps = {
  currency: string;
  defaultPlatformShare: null | string | undefined;
  index: number;
};

export const NetFee = ({ currency, defaultPlatformShare, index }: NetFeeProps) => {
  const id = useId();
  const isCpmRevenue = useIsCpmRevenue(index);
  const { t } = useTranslation();

  const netFee = useNetFeeCalculation(defaultPlatformShare, index);

  const netFeeSlotProps: TextFieldSlotsAndSlotProps<InputBaseProps>['slotProps'] = {
    input: {
      endAdornment: isCpmRevenue ? undefined : <InputAdornment position="end">%</InputAdornment>,
      startAdornment: isCpmRevenue ? <InputAdornment position="start">{currency}</InputAdornment> : undefined,
    },
  };

  return (
    <FormFieldWithInfo
      dataTest="net-fee"
      info={isCpmRevenue ? t(netFeeTooltip.cpm) : t(netFeeTooltip.pom)}
      margin="dense"
      tooltipTop="22px"
    >
      <FormLabel htmlFor={id}>{t('Net Fee')}</FormLabel>
      <TextField
        data-test="net-fee"
        disabled
        id={id}
        placeholder={t('N / A')}
        slotProps={netFee ? netFeeSlotProps : undefined}
        value={netFee ?? t('N / A')}
        variant="outlined"
      />
    </FormFieldWithInfo>
  );
};
